import { render } from "./UserCenterRecharge.vue?vue&type=template&id=10b41534&scoped=true"
import script from "./UserCenterRecharge.vue?vue&type=script&lang=js"
export * from "./UserCenterRecharge.vue?vue&type=script&lang=js"

import "./UserCenterRecharge.vue?vue&type=style&index=0&id=10b41534&lang=scss&scoped=true"

import exportComponent from "D:\\work\\code\\tranWorld\\traneasy-reply(易回复官网)\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b41534"]])

export default __exports__